<template>
<section class="height100vh" style="padding-top:0;height: calc(100vh - 68px);">
    <div class="wrap">           
        <div class="new_content_box1">
            <h3 class="title"><span>무엇을 중요하게 생각하시나요?</span></h3>
            <ul class="reservation_ul">

                <li v-for="bookingchoice in Object.values(BOOKING_CHOICE)" :key="`booking-choice-item-${bookingchoice.id}`">
                    <div class="chk_box">
                        <input type="checkbox" class="chk_box" 
                            :id="`bookingchoice-${bookingchoice.id}`" 
                            :name="`bookingchoice-${bookingchoice.id}`" 
                            v-model="bookingWrite.choice" 
                            :value="bookingchoice.id"
                        >
                        <label :for="`bookingchoice-${bookingchoice.id}`"></label>
                        <label :for="`bookingchoice-${bookingchoice.id}`">{{bookingchoice.title}}</label>
                    </div>
                </li>        
            </ul>
        </div>
        
        <div class="new_content_box2">
            <h3 class="title">
                <span>추가로 요청하실 부분이 있나요?</span>
            </h3>
            
            <textarea 
                class="reservation_textarea" 
                placeholder="더 둘러 보고 싶은 모델, 선호하는 색상 등 자유롭게 의견을 남겨 주세요."
                v-model="bookingWrite.userMemo"
            ></textarea>
        </div>    
    </div>

    <button class="default_fixed_btn" @click="validate()">다음</button>
</section>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name:'BookingInputDetail',
    data() {
        return {
        }
    },
    computed: {
        ...mapState({
            bookingItem: state => state.booking.item,
            bookingWrite: state => state.booking.itemWrite,

            BOOKING_CHOICE: state => state.codeDictionary.items.BOOKING_CHOICE,
        }),

        bookingId(){
            return Number(this.$route.params.bookingId);
        },

        routerPath() {
            let path = '/booking/inputDate';
            return (this.bookingId) ? `${path}/${this.bookingId}`: path;
        },
    },
    created () {
        if(this.bookingId) {
            this.bookingWrite.choice = this.bookingItem.choice.split(',');
            this.bookingWrite.userMemo = this.bookingItem.userMemo;
        }
        this.$store.commit('SHOW_ONLOAD');
    },
    methods: {
        validate() {
            try {
                if(this.bookingWrite.userMemo.length > 0 &&
                    this.bookingWrite.userMemo.length < 10) throw '10자 이상 입력해 주세요';
            }
            catch (errorMsg) {
                this.$store.commit('OPEN_MODAL', {
                    title: '알림', 
                    content: errorMsg, 
                    btnOne: '확인', 
                });
                return false;
            }

            this.next();
        },
        next() {
            this.$router.push(this.routerPath)
        }
    },
}
</script>

<style lang="scss" scoped>

</style>